import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "cs_cart";

const lineKey = (productId, size) => `${productId}::${size || ""}`;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, size = null, qty = 1) => {
    setItems((prev) => {
      const k = lineKey(product.id, size);
      const existing = prev.find((i) => i.key === k);
      if (existing) {
        return prev.map((i) => (i.key === k ? { ...i, qty: Math.min(i.qty + qty, 50) } : i));
      }
      return [
        ...prev,
        {
          key: k, product_id: product.id, title: product.title, size,
          price: product.price, image_url: product.image_url, category: product.category,
          pickup: product.pickup !== false, shipping: !!product.shipping,
          shipping_fee: product.shipping_fee || 0, qty: Math.min(qty, 50),
        },
      ];
    });
  };

  const updateQty = (key, qty) =>
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty: Math.max(1, Math.min(qty, 50)) } : i)));
  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const count = items.reduce((n, i) => n + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + (Number(i.price) || 0) * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
